(() => {
  if (window.__cloudSearchPresearchBlogImagesInit) return;
  window.__cloudSearchPresearchBlogImagesInit = true;

  const imageCache = new Map();
  const inFlight = new Map();
  let debounceTimer = null;
  let isMutating = false;

  function getRowUrl(row) {
    if (row.matches('a.cs-item[href]')) return row.getAttribute('href');
    return (
      row.querySelector('a[href*="/blogs/"], a[href*="/pages/"], a[id$="-name"][href]')?.getAttribute('href') ||
      row.querySelector('a.list-image[href]')?.getAttribute('href')
    );
  }

  function getArticlePath(href) {
    if (!href) return null;
    try {
      const path = new URL(href, window.location.origin).pathname;
      if (/\/blogs\/[^/]+\/[^/]+/.test(path)) return path;
      return null;
    } catch {
      return null;
    }
  }

  function hasUsableImage(row) {
    const img = row.querySelector('.list-image img');
    if (!img) return false;
    const src = (img.getAttribute('src') || '').trim();
    if (!src) return false;
    if (!img.complete) return true;
    return img.naturalWidth > 0;
  }

  function ensureListImage(row) {
    let listImage = row.querySelector(':scope > .list-image, :scope > a.list-image');
    if (listImage) return listImage;

    listImage = document.createElement('span');
    listImage.className = 'list-image';
    listImage.setAttribute('tabindex', '-1');

    isMutating = true;
    row.insertBefore(listImage, row.firstChild);
    isMutating = false;
    return listImage;
  }

  function markReserved(listImage) {
    const img = listImage.querySelector('img');
    if (img) img.hidden = true;
    listImage.classList.add('list-image--reserved');
  }

  function placeImage(row, listImage, src, alt) {
    let img = listImage.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.alt = alt || '';
      listImage.appendChild(img);
    }

    if (img.getAttribute('src') === src) {
      listImage.classList.remove('list-image--reserved');
      img.hidden = false;
      return;
    }

    isMutating = true;
    listImage.classList.remove('list-image--reserved');
    img.hidden = false;
    img.alt = alt || '';
    img.src = src;
    isMutating = false;

    img.addEventListener(
      'error',
      () => {
        if (!row.isConnected) return;
        markReserved(listImage);
      },
      { once: true }
    );
  }

  function parseArticleImage(html) {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    const img = doc.querySelector('.presearch-article-image-source');
    if (!img) return null;
    const src = (img.getAttribute('src') || '').trim();
    if (!src) return null;
    return { src, alt: img.getAttribute('alt') || '' };
  }

  function fetchArticleImage(path) {
    if (imageCache.has(path)) return Promise.resolve(imageCache.get(path));
    if (inFlight.has(path)) return inFlight.get(path);

    const req = fetch(`${path}?section_id=presearch-article-image`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        const data = parseArticleImage(html);
        imageCache.set(path, data);
        return data;
      })
      .catch(() => {
        imageCache.set(path, null);
        return null;
      })
      .finally(() => inFlight.delete(path));

    inFlight.set(path, req);
    return req;
  }

  function syncRow(row) {
    const href = getRowUrl(row);
    const path = getArticlePath(href);
    if (!path) return;

    if (hasUsableImage(row)) return;

    const listImage = ensureListImage(row);

    if (imageCache.has(path)) {
      const cached = imageCache.get(path);
      if (cached) placeImage(row, listImage, cached.src, cached.alt);
      else markReserved(listImage);
      return;
    }

    fetchArticleImage(path).then((data) => {
      if (!row.isConnected) return;
      if (data) placeImage(row, listImage, data.src, data.alt);
      else markReserved(listImage);
    });
  }

  function syncBlogImages(root) {
    const block = root.querySelector('.results-block.block-pages');
    if (!block) return;

    block.querySelectorAll('dt.cs-item, a.cs-item').forEach((row) => syncRow(row));
  }

  function scheduleSync(root) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      syncBlogImages(root);
    }, 100);
  }

  function bind(root) {
    if (!root || root.dataset.blogImagesBound) return;
    root.dataset.blogImagesBound = 'true';

    syncBlogImages(root);

    const block = root.querySelector('.results-block.block-pages') || root;
    new MutationObserver(() => {
      if (isMutating) return;
      scheduleSync(root);
    }).observe(block, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach(bind);

    new MutationObserver(() => {
      document.querySelectorAll('#cloud-search-results, .cloud-search-results').forEach((el) => {
        if (!el.dataset.blogImagesBound) bind(el);
        else scheduleSync(el);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
